import * as React from "react";
import { connect } from "react-redux";
// import { getReferralLink } from "../../reducers/methods";

import { Text, TextProps } from "../../components/Text/Text";
import { StoreState } from "../../reducers";

interface ReferralLinkProps extends TextProps {
  referralLink: (channel: string) => string;
}

class ReferralLink extends React.Component<ReferralLinkProps> {
  render() {
    const { children, ...props } = this.props;

    return <Text content={this.props.referralLink} {...props} />;
  }
}

function mapStateToProps(state: StoreState) {
  return {
    // referralLink: getReferralLink(state),
  };
}

export default connect(mapStateToProps, {})(ReferralLink);
